/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespShippingReturns_viewer = {
    readonly isItemInvoiceEnabled: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailShipping_viewer">;
    readonly " $refType": "PdpRespShippingReturns_viewer";
};
export type PdpRespShippingReturns_viewer$data = PdpRespShippingReturns_viewer;
export type PdpRespShippingReturns_viewer$key = {
    readonly " $data"?: PdpRespShippingReturns_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespShippingReturns_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespShippingReturns_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isItemInvoiceEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "INVOICE"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"INVOICE\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '2d6628fe4b6f947e5df19c682cc05e4f';
export default node;
